var _style, _path, _path2, _path3, _path4, _polygon;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatio4X5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1352.8 1080",
    style: {
      enableBackground: "new 0 0 1352.8 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F6F2;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#53C6D7;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{opacity:0.25;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1352.8,87.9v904.2c0,48.5-26.8,87.9-59.8,87.9H59.8c-33,0-59.8-39.3-59.8-87.9V87.9C0,39.3,26.8,0,59.8,0H1293 c3.7,0,7.3,0.5,10.8,1.4C1331.7,8.9,1352.8,44.8,1352.8,87.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754.9,1080H56.3l302.8-440.7c20.7-30.1,72.4-30.1,93,0L754.9,1080z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1297.7,1080H382.2l416-620.2c18.6-27.7,65-27.7,83.5,0L1297.7,1080z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1352.8,87.9v156.7c-24.6,10.9-51.7,16.9-80.2,16.9c-112.4,0-203.5-94-203.5-210c0-17.8,2.1-35,6.2-51.5h215.5 c4.5,0,8.9,0.5,13.1,1.4C1331.7,8.9,1352.8,44.8,1352.8,87.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1352.8,0 1352.8,1080 0,1080 0,0 235,0 235,1079.4 1098.6,1079.4 1098.6,0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatio4X5);
export default __webpack_public_path__ + "static/media/ratio4x5.8836d50f8673254c28600ddd59b554cb.svg";
export { ForwardRef as ReactComponent };